import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';

import { resetEmailStyle } from '@app/features/customBrandSetting/email';
import { modalClose } from '@app/store/modal/actions';

const propTypes = {
  onClose: PropTypes.func,
  onResetCustomEmailSettingStyleRequest: PropTypes.func,
};

const defaultProps = {
  onClose() {},
  onResetCustomEmailSettingStyleRequest() {},
};

export class CustomEmailSettingStyleResetConfirmModalComponent extends Component {
  constructor(props) {
    super(props);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleCancel() {
    const { onClose } = this.props;
    onClose();
  }

  handleClose() {
    const { onClose, onResetCustomEmailSettingStyleRequest } = this.props;
    onResetCustomEmailSettingStyleRequest();
    onClose();
  }

  render() {
    return (
      <div className="Container Container--max-xxs">
        <div className="Card Card--pop align-center box-6x">
          <h4 className="space-2x">
            <strong>설정 되돌리기</strong>
          </h4>
          <p className="space-4x">
            설정된 스타일은 사라지고
            <br />
            기본 이메일 스타일로 돌아갑니다.
          </p>
          <button
            className="Btn Btn--bold-mobile"
            name="cancel"
            type="button"
            onClick={this.handleCancel}
          >
            취소
          </button>
          <button
            className="Btn Btn--primary Btn--bold-mobile"
            name="close"
            type="button"
            onClick={this.handleClose}
          >
            확인
          </button>
        </div>
      </div>
    );
  }
}

CustomEmailSettingStyleResetConfirmModalComponent.propTypes = propTypes;
CustomEmailSettingStyleResetConfirmModalComponent.defaultProps = defaultProps;

const mapDispatchToProps = {
  onClose: modalClose,
  onResetCustomEmailSettingStyleRequest: resetEmailStyle,
};

export default connect(null, mapDispatchToProps)(CustomEmailSettingStyleResetConfirmModalComponent);
